<template>
  <span
    class="fc-system-actor"
    :class="{ 'fc-system-actor--approved': approved }"
    :style="sizeStyle"
    :data-testid="dataTestId"
  >
    <span class="fc-system-actor__disc" aria-hidden="true">
      <img
        src="/img/icons/fbc-icons/SystemActorGlyph.svg"
        alt=""
      />
    </span>
    <img
      v-if="approved"
      class="fc-system-actor__badge"
      src="/img/icons/fbc-icons/SystemActorApprovalBadge.svg"
      alt=""
    />
  </span>
</template>

<script>
import './FcSystemActorAvatar.scss';

export default {
  name: 'FcSystemActorAvatar',

  props: {
    approved: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 32,
    },
    dataTestId: {
      type: String,
      default: 'fc-system-actor',
    },
  },

  computed: {
    sizeStyle() {
      return { '--fc-system-actor-size': `${this.size}px` };
    },
  },
};
</script>
